import { useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive'

import { StylePanelProps } from '@/lib/stylePanel'
import useResponsivePadding from '@/lib/useResponsivePadding'

import styles from './Thehulk.module.css'

export type ThehulkProps = {
  title: string
  subtitle: string
  description: React.ReactNode
  asset: { src: string; alt: string; focus?: string; wash_opacity?: number } | undefined
  bannerContent: any
  subBannerContent?: any
  cropImage?: boolean
} & StylePanelProps

export const PhnxThehulk: React.FC<ThehulkProps> = ({
  title,
  subtitle,
  description,
  bannerContent,
  subBannerContent,
  cropImage,
  asset,
  padding,
  backgroundColor,
  textColor,
}) => {
  const paddingStyles = useResponsivePadding(padding)

  const [hasMounted, setHasMounted] = useState(false)
  const isDesktop = useMediaQuery({ query: '(min-width: 1500px)' })
  const [imageUri, setImageUri] = useState<string>('')

  useEffect(() => {
    setHasMounted(true)
  }, [])

  useEffect(() => {
    if (!hasMounted) return
    if (asset?.src) {
      const imageHeightWidth = isDesktop ? '1500x500' : '1000x700'
      let imageUri = `${asset.src}/m/filters:quality(80)`
      if (cropImage) {
        imageUri = `${asset.src}/m/${imageHeightWidth}/filters:quality(80)`
      }

      if (asset?.focus) {
        imageUri = `${imageUri}:focal(${asset.focus})`
      }
      setImageUri(imageUri)
    }
  }, [asset, isDesktop, cropImage, hasMounted])

  if (!hasMounted) return null

  const imageClass = asset?.src ? styles['has-image'] : ''

  let wash_opacity = asset?.wash_opacity ? asset.wash_opacity : 0

  const style = { ...paddingStyles, color: textColor }

  return (
    <div
      className={`${styles['thehulk']} ${imageClass} ${styles[imageUri === '' ? 'noBackgroundImage' : '']}`}
      style={{ position: 'relative', display: 'flex', flexDirection: 'column' }}
      data-testid="herobanner"
    >
      {/* Container for background image */}
      <div
        style={{
          position: 'absolute',
          backgroundImage: `url("${imageUri}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'top',
          borderImage:
            imageUri && wash_opacity
              ? `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)) 1 fill / 1 / 0 stretch`
              : 'none',
          backgroundClip: 'padding-box',
          height: isDesktop ? '512px' : '656px',
          width: '100%',
          backgroundColor: backgroundColor ? backgroundColor : 'black',
          transition: 'height 0.3s ease',
        }}
      ></div>
      <div className={styles['container']}>
        <div className={styles['leftContainer']}>
          <div className={styles['text-container']}>
            <div style={style} className="stylepanel">
              <style jsx>{`
                stylepanel {
                  ${paddingStyles}
                }
              `}</style>
              {subtitle && <h5 className={`title ${styles['hulk-title']}`}>{subtitle}</h5>}
              {title && <h1 className={styles['hulk-subtitle']}>{title}</h1>}
              {description && <div className={styles['hulk-content']}>{description}</div>}
            </div>
          </div>
          <div className={styles['subBannerContent']}>{subBannerContent && subBannerContent}</div>
        </div>
        <div className={styles['rightContainer']}>{bannerContent} </div>
      </div>
    </div>
  )
}
